import { Grid } from "@mui/material";
import { PageBreadcrumbs, PageSubtitle, PageTitle } from "pages/Layouts/components/PageTitleContainer";
import useLabelPrintRequest from "hooks/useLabelPrintRequest";
import { BoxType } from "types/assetRetrieval";
import BoomerangPrintComponent from "./BoomerangPrintComponent";

export default function BoomerangPrintLabels() {
  const { labelComponentsData } = useLabelPrintRequest();

  return (
    <>
      <PageBreadcrumbs links={[{ label: "Fulfillment" }, { label: "Boomerang" }]} />
      <PageTitle>Boomerang Orders</PageTitle>
      <PageSubtitle>Pack and ship boomerang orders.</PageSubtitle>

      <Grid container spacing={2} pt={2}>
        <Grid item xs={12} md={4}>
          <BoomerangPrintComponent boxType={BoxType.laptop} labelComponentData={labelComponentsData?.laptop} />
        </Grid>
        <Grid item xs={12} md={4}>
          <BoomerangPrintComponent
            boxType={BoxType.laptopTablet}
            labelComponentData={labelComponentsData?.laptopTablet}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <BoomerangPrintComponent
            boxType={BoxType.laptopMobile}
            labelComponentData={labelComponentsData?.laptopMobile}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <BoomerangPrintComponent boxType={BoxType.tablet} labelComponentData={labelComponentsData?.tablet} />
        </Grid>
        <Grid item xs={12} md={4}>
          <BoomerangPrintComponent
            boxType={BoxType.tabletMobile}
            labelComponentData={labelComponentsData?.tabletMobile}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <BoomerangPrintComponent
            boxType={BoxType.mobilePhone}
            labelComponentData={labelComponentsData?.mobilePhone}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <BoomerangPrintComponent boxType={BoxType.desktop} labelComponentData={labelComponentsData?.desktop} />
        </Grid>
        <Grid item xs={12} md={4}>
          <BoomerangPrintComponent boxType={BoxType.monitor} labelComponentData={labelComponentsData?.monitor} />
        </Grid>
        <Grid item xs={12} md={4}>
          <BoomerangPrintComponent boxType={BoxType.bulk} labelComponentData={labelComponentsData?.bulk} />
        </Grid>
      </Grid>
    </>
  );
}
